import { Component } from '@angular/core';
import { SvgComponent, svgBaseStyles } from '@app/shared/components/svgs/svg-component';
import { COLOR_7P_CYAN, COLOR_7P_DARK_GRAY } from '../utils';

@Component({
  selector: 'topo-7P-logo-svg',
  template: `
    <svg
      style="border-radius: 50%;"
      [attr.height]="size()"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <circle
        cx="12"
        cy="12"
        r="12"
        [attr.fill]="backgroundColor" />
      <path
        d="M8.74105 4.67145C10.0123 4.67145 11.2824 4.67145 12.5537 4.67145C12.8968 4.67145 12.9076 4.68631 12.8511 5.01926C12.0072 9.98633 11.1596 14.9534 10.3229 19.9229C10.2796 20.1816 10.1845 20.2757 9.93167 20.2658C9.50912 20.2497 9.08415 20.2522 8.66159 20.2658C8.45452 20.272 8.3221 20.1915 8.20412 20.0244C7.79239 19.4415 7.36141 18.8709 6.95691 18.2817C6.87384 18.1616 6.82689 17.9685 6.85097 17.825C7.34094 14.8779 7.84416 11.9321 8.34497 8.98747C8.41239 8.59016 8.40998 8.5852 8.02113 8.58397C7.42401 8.58273 6.82689 8.57283 6.23097 8.58892C5.96612 8.59634 5.78313 8.5196 5.62302 8.29186C5.2438 7.75715 4.82726 7.25092 4.45045 6.71497C4.36016 6.58872 4.32043 6.38944 4.33728 6.23225C4.38182 5.81142 4.47693 5.39554 4.53592 4.97594C4.56842 4.74572 4.67316 4.6665 4.89949 4.6665C6.18041 4.67517 7.46013 4.67022 8.74105 4.67022V4.67145Z"
        [attr.fill]="fillColor" />
      <path
        d="M15.5815 4.70368C16.1389 4.70368 16.706 4.63685 17.2537 4.71606C19.1257 4.98341 20.202 6.58382 19.877 8.5704C19.6639 9.87498 19.4375 11.1771 19.1992 12.4767C18.8019 14.6366 16.789 16.3422 14.6485 16.3471C13.8299 16.3496 13.0113 16.3471 12.1938 16.3422C11.8568 16.341 11.8495 16.3273 11.9073 15.9833C12.0855 14.9336 12.2745 13.8853 12.4334 12.832C12.4828 12.5052 12.614 12.4086 12.9246 12.4235C13.4338 12.4495 13.9443 12.4334 14.4547 12.4322C15.0037 12.4309 15.3685 12.1252 15.466 11.5806C15.6249 10.6869 15.7705 9.79205 15.9355 8.89964C15.9812 8.65333 15.9018 8.58401 15.673 8.58649C14.9507 8.59392 14.2284 8.5803 13.5073 8.5902C13.2496 8.59392 13.1666 8.51718 13.2171 8.24363C13.4122 7.1668 13.5964 6.08748 13.7685 5.00693C13.8094 4.74948 13.9178 4.66036 14.1682 4.66903C14.6389 4.68512 15.112 4.67398 15.5839 4.67398C15.5839 4.68512 15.5839 4.69502 15.5839 4.70616L15.5815 4.70368Z"
        [attr.fill]="fillColor" />
    </svg>
  `,
  styles: svgBaseStyles
})
export class SevenPLogoSVGComponent extends SvgComponent {
  protected backgroundColor = COLOR_7P_DARK_GRAY;
  protected fillColor = COLOR_7P_CYAN;
}
